/**
 * Column totals for quotation / sales-order / wire line items.
 * Pieces and kilograms are summed separately — unlike units are never added.
 */

const WEIGHT_UOMS = new Set(['kgs', 'kg', 'mt']);

export const isWeightLine = (item = {}) =>
  WEIGHT_UOMS.has(item.uom) || item.quantity_unit === 'kg' || item.quantity_unit === 'mt';

export function computeLineItemTotals(items = []) {
  return items.reduce((acc, item) => {
    const qty = Number(item.quantity) || 0;
    const netWeight = Number(item.net_weight_grams || item.live_part?.net_weight_grams) || 0;
    const weightLine = isWeightLine(item);
    const lineKg = weightLine ? (Number(item.total_kg) || qty) : (netWeight * qty) / 1000;

    acc.count += 1;
    acc.qtyPcs += weightLine ? 0 : qty;
    acc.qtyKg += weightLine ? (Number(item.total_kg) || qty) : 0;
    acc.totalWeightKg += lineKg;
    acc.impliedPieces += weightLine ? (netWeight ? (lineKg * 1000) / netWeight : 0) : qty;
    acc.coils += Number(item.no_of_coils) || 0;
    acc.toolingCost += Number(item.tooling_cost) || 0;
    acc.sampleCost += Number(item.sample_cost) || 0;
    acc.lineTotal += Number(item.line_total) || 0;
    return acc;
  }, {
    count: 0, qtyPcs: 0, qtyKg: 0, totalWeightKg: 0, impliedPieces: 0,
    coils: 0, toolingCost: 0, sampleCost: 0, lineTotal: 0,
  });
}

const inr = (value, decimals = 0) => Number(value || 0).toLocaleString('en-IN', {
  minimumFractionDigits: decimals,
  maximumFractionDigits: decimals,
});

/** "10,000 Pcs + 1,250.00 Kg" — only the units actually present. */
export function formatQtyTotal(totals) {
  const parts = [];
  if (totals.qtyPcs) parts.push(`${inr(totals.qtyPcs)} Pcs`);
  if (totals.qtyKg) parts.push(`${inr(totals.qtyKg, 2)} Kg`);
  return parts.join(' + ') || '-';
}

export function formatWeightTotal(totals) {
  return totals.totalWeightKg ? inr(totals.totalWeightKg, 2) : '-';
}

export function formatNumberTotal(value, decimals = 2) {
  return value ? inr(value, decimals) : '-';
}
